export default __webpack_public_path__ + "static/media/recrumentsearch.47123742.svg";